import { SharedDocument } from 'types/Document';
import { useSelectedLinkContext } from 'contexts';
import {Profile} from 'components/icons';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  icon: {
    marginBottom: -12,
    marginLeft: -12,
    position: 'relative',
    width: 24,
  },
}), { name: 'CreatorIcon' });

type CreatorIconProps = {
  document: SharedDocument;
};

const CreatorIcon = ({ document }: CreatorIconProps): JSX.Element => {
  const classes = useStyles();

  const { selectedLink } = useSelectedLinkContext();

  if (document.creator !== selectedLink?.userKey) {
    return null;
  }

  return <Profile className={classes.icon} />;
};

export default CreatorIcon;